function includeProtocol(url) {
  return url.indexOf("http") >= 0 ? url : `https://${url}`;
}

function linkify(text) {
  var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/gi;
  return text.replace(urlRegex, function(url) {
    return `<a class="text-blue" target="_blank" href="${includeProtocol(
      url
    )}">${url}</a>`;
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const elements = document.getElementsByClassName("linkify");

  for (let i = 0; i < elements.length; i++) {
    elements[i].innerHTML = linkify(elements[i].innerText);
  }
});
